import { guidePaths } from './features/Guides/guidePaths.js';
import React, { useLayoutEffect } from 'react';
import { Layout } from 'antd';
import useMobileCheck from './mobile';
import {
  Outlet,
  useLocation,
} from "react-router-dom";

import Footer from './shared/Footer';
import HeroSection from './features/Home/HeroSection';
import CTASection from './features/Home/CTASection';
import { COLOURS } from './colours';
import BrevoTracker from "./BrevoTracker";
import PostHogTracker from './PostHogTracker';

const { Content } = Layout;

const App = () => { 
  const { isMobile } = useMobileCheck();
  const { pathname } = useLocation();
  const cleanPath = pathname.replace(/\/+$/, '') || '/';
  useLayoutEffect(() => {
    if (pathname === '/compare' || pathname.startsWith('/compare/')) {
      const pageScroller = document.getElementById('root');
      if (pageScroller) pageScroller.scrollTop = 0;
      window.scrollTo(0, 0);
    }
  }, [pathname]);
  const isComparisonPage = cleanPath === '/compare' || cleanPath.startsWith('/compare/');
  const isSwitchGuide = isComparisonPage || ['/your-club', '/sports-club-app', '/sports-club-management-software', '/guides/club-attendance-register', '/guides/badminton-club-membership-form', '/guides/switch-from-playwaze', '/guides/switch-from-spond', '/test-club', '/guides/switch-from-justgo-to-shuttleops', '/guides/badminton-pegboard'].includes(cleanPath);
  return ( <Layout style={{ background: COLOURS.BACKGROUND }}>
    <Content style={{ 
      // margin: '0 auto', 
      padding: isMobile ? '1rem' : "1.88rem" 
    }}>
      {!isSwitchGuide && !guidePaths[cleanPath] && <HeroSection />}
      <Outlet />
      {!isSwitchGuide && !isComparisonPage && <CTASection />}
      <Footer />
    </Content>
    <BrevoTracker />
    <PostHogTracker />
  </Layout>
  )
}

export default App;
